import { capitalizeFirstLetter } from './DataTransformUtils';
import moment from 'moment';

//////////////////////////////////////////////////////////

/**
 * Charts
 *
 *
 * NOTE: If you increment dataset limit get sure you add
 * the colors of new datasets
 */
export const DATA_SET_LIMIT = 5;
export const DATA_SETS_COLORS = [
  '#1890FF',
  '#2FC25B',
  '#FACC14',
  '#F1251A',
  '#8543E0',
];

export const hasOP = Object.prototype.hasOwnProperty;

export const spaceCode = '\u00A0';

export function sortByFullName(a, b) {
  console.log('sort full name hits-------------------');
  if (a && b) {
    if (a.first_name && b.first_name) {
      const result = capitalizeFirstLetter(a.first_name).localeCompare(
        capitalizeFirstLetter(b.first_name)
      );
      if (result === 0 && a.last_name && b.last_name) {
        // console.log("compare last_name")
        return capitalizeFirstLetter(a.last_name).localeCompare(
          capitalizeFirstLetter(b.last_name)
        );
      }

      // console.log("compare first_name", result);
      return result;
    }
  }
  return 0;
}

export function fixedZero(val) {
  return val * 1 < 10 ? `0${val}` : val;
}

export function getTimeDistance(type, rangename) {
  const now = new Date();
  const oneDay = 1000 * 60 * 60 * 24;

  if (type === 'day') {
    if (rangename === 'start') {
      now.setHours(0);
    }
    if (rangename === 'end') {
      now.setDate(now.getDate() + 1);
    }
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    return [moment(now), moment(now.getTime() + (oneDay - 1000))];
  }

  if (type === 'week') {
    let day = now.getDay();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);

    if (day === 0) {
      day = 6;
    } else {
      day -= 1;
    }

    const beginTime = now.getTime() - day * oneDay;
    if (rangename === 'start') {
      return [moment(beginTime)];
    }
    if (rangename === 'end') {
      return [moment(beginTime + 7 * oneDay)];
    }
    /*  let weekTab = [moment(beginTime), moment(beginTime + (7 * oneDay))]
    console.log( weekTab,"when tab changes to week")
    return weekTab; */
  }

  if (type === 'month') {
    const year = now.getFullYear();
    const month = now.getMonth();
    const nextDate = moment(now).add(1, 'months');
    const nextYear = nextDate.year();
    const nextMonth = nextDate.month();

    if (rangename === 'start') {
      return [moment(`${year}-${fixedZero(month + 1)}-01 00:00:00`)];
    }
    if (rangename === 'end') {
      return [moment(`${nextYear}-${fixedZero(nextMonth + 1)}-01 00:00:00`)];
    }
    /* return [
      moment(`${year}-${fixedZero(month + 1)}-01 00:00:00`),
      moment(
        moment(
          `${nextYear}-${fixedZero(nextMonth + 1)}-01 00:00:00`
        ).valueOf() - 1000
      )
    ]; */
  }
  if (type === 'year') {
    const year = now.getFullYear();
    if (rangename === 'start') {
      return [moment(`${year}-01-01 00:00:00`)];
    }
    if (rangename === 'end') {
      //console.log(year + 1, "year added");
      return [moment(`${year + 1}-01-01 00:00:00`)];
    }
    //return [moment(`${year}-01-01 00:00:00`), moment(`${year}-12-31 23:59:59`)];
  }
  if (type === 'custom') {
    now.setMinutes(0);
    now.setSeconds(0);
    if (rangename === 'start') {
      now.setHours(0);
      //console.log([moment(now)], "custom start");
      return [moment(now)];
    }
    if (rangename === 'end') {
      now.setHours(
        moment(now)
          .add(1, 'hour')
          .format('H')
      );
      //console.log([moment(now)], "custom end");
      return [moment(now)];
    }
  }
}

export function getIntervalOnTabs(type) {
  switch (type) {
    case 'day':
      return 'hours';
    case 'week':
      return 'days';
    case 'month':
      return 'days';
    case 'year':
      return 'months';
    default:
      return 'hours';
  }
}

export function readCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));

  if (match) {
    if (match[2].startsWith('[') || match[2].startsWith('{')) {
      return JSON.parse(match[2]);
    } else {
      return match[2];
    }
  }
}

export function clearPerformanceCookies() {
  const cookieNames = [
    'perf_time_view',
    'perf_time_range',
    'perf_hours_start',
    'perf_hours_end',
    'perf_groups',
    'perf_selected_worker',
    'perf_selected_worker_index',
  ];

  cookieNames.forEach(name => {
    document.cookie = `${name}=; Max-Age=0; path=/`;
    document.cookie = `${name}=; Max-Age=0; path=/home`;
  });
}
